import { useState } from "react";
import { Drawer, Button } from "antd";
import { CloseOutlined } from "@ant-design/icons";

const CheckInDrawer = ({
  checkInDrawerOpen,
  setCheckInDrawerOpen,
  selectedReservation,
  tableList,
  handleReservationCheckIn,
}) => {
  const [selectedCheckInTable, setSelectedCheckInTable] = useState(null);

  return (
    <Drawer
      open={checkInDrawerOpen}
      onClose={() => {
        setSelectedCheckInTable(null);
        setCheckInDrawerOpen(false);
      }}
      width="80%"
      styles={{ mask: { backgroundColor: "rgba(0,0,0,0.3)" } }}
      styles={{ body: { padding: "20px 30px", background: "#fff", height: "100%" } }}
      styles={{ header: { display: "none" } }}
    >
      {/* Close Icon */}
      <div
        style={{
          position: "absolute",
          right: 30,
          top: 20,
          cursor: "pointer",
          fontSize: 20,
          color: "#444",
        }}
        onClick={() => setCheckInDrawerOpen(false)}
      >
        <CloseOutlined />
      </div>

      <h1 style={{ fontSize: 24, fontWeight: 600, marginBottom: 5 }}>
        Select Table for Check-In
      </h1>

      {selectedReservation && (
        <p style={{ color: "#555", marginBottom: 20, fontSize: 14 }}>
          Guest: <b>{selectedReservation.name}</b> • {selectedReservation.guests} guests
        </p>
      )}

      {/* TABLE GRID */}
      <div
        style={{
          overflowY: "auto",
          height: "calc(100% - 120px)",
          paddingRight: 10,
        }}
      >
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fill, minmax(260px, 1fr))",
            gap: "20px",
          }}
        >
          {tableList
            .filter((tbl) => tbl.statusType === "OPN")
            .map((tbl) => (
              <div
                key={tbl.cwrFbTableId}
                onClick={() => setSelectedCheckInTable(tbl)}
                style={{
                  borderRadius: 16,
                  padding: "22px",
                  height: 150,
                  cursor: "pointer",
                  textAlign: "center",
                  background:
                    selectedCheckInTable?.cwrFbTableId === tbl.cwrFbTableId
                      ? "#DBEAFE"
                      : "#F5F5F5",
                  border:
                    selectedCheckInTable?.cwrFbTableId === tbl.cwrFbTableId
                      ? "3px solid #2563EB"
                      : "2px solid #E0E0E0",
                  transition: "0.2s",
                }}
              >
                <div style={{ fontSize: 22, fontWeight: 700, marginBottom: 8 }}>{tbl.name}</div>
                <div style={{ fontSize: 14, color: "#666" }}>AVAILABLE</div>
              </div>
            ))}

          {tableList.filter((tbl) => tbl.statusType === "OPN").length === 0 && (
            <p
              style={{
                textAlign: "center",
                color: "#888",
                marginTop: 40,
                gridColumn: "1/-1",
              }}
            >
              No available tables
            </p>
          )}
        </div>
      </div>

      {/* FOOTER BUTTONS */}
      <div
        style={{
          position: "absolute",
          bottom: 0,
          left: 0,
          width: "100%",
          background: "#fff",
          padding: "15px 30px",
          borderTop: "1px solid #E5E7EB",
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        <Button
          style={{ height: 42, borderRadius: 10, width: "48%" }}
          onClick={() => {
            setSelectedCheckInTable(null);
            setCheckInDrawerOpen(false);
          }}
        >
          Cancel
        </Button>

        <Button
          type="primary"
          disabled={!selectedCheckInTable}
          style={{
            height: 42,
            borderRadius: 10,
            width: "48%",
            fontWeight: 600,
            background: selectedCheckInTable ? "#2F3856" : "#9CA3AF",
          }}
          onClick={() => {
            handleReservationCheckIn(selectedReservation, selectedCheckInTable, "STD");
            setSelectedCheckInTable(null);
            setCheckInDrawerOpen(false);
          }}
        >
          Confirm Allocation
        </Button>
      </div>
    </Drawer>
  );
};

export default CheckInDrawer;
